import React, { useState } from "react";
import { FaStar } from "react-icons/fa";

const reviews = [
  {
    name: "Xantosh Nohar",
    avatar: `https://ui-avatars.com/api/?name=X+N&background=random`,
    date: "1 day ago",
    text: "Na mijn behandeling van de auto ben ik zeer tevreden met de prestaties van de auto. Hij rijd en schakelt als een raket en dat is waar ik voor kwam. De service en de gastvrijheid zit goed in het bedrijf hele toffe gozer, zeker een aanrader om hier te auto onderhanden te nemen !",
  },
  {
    name: "Björn van Gils",
    avatar: `https://ui-avatars.com/api/?name=Björn+Gils&background=random`,
    date: "2 days ago",
    text: "Vandaag mijn auto stage 1 met versnellingsbak laten tunen. Super tevreden! Ik zou zeker aanraden om hierheen te gaan.",
  },
  {
    name: "Rajeev Raghoenath",
    avatar: `https://ui-avatars.com/api/?name=Rajeev+Raghoenath&background=random`,
    date: "4 days ago",
    text: "Ik heb onlangs mijn Ford Transit laten chippen bij X-TREMETUNINGS en ik ben zeer tevreden over het resultaat. Vanaf het eerste contact was de communicatie duidelijk en professioneel. Ze namen de tijd om uit te leggen wat ik kon verwachten en beantwoordden al mijn vragen op een begrijpelijke manier. Na de tuning merkte ik meteen verschil: de motor reageert vlotter, het koppel is aanzienlijk toegenomen en de Transit rijdt gewoon veel soepeler. Ook het brandstofverbruik lijkt wat gunstiger uit te vallen, wat mooi meegenomen is. De service was top, de wachtruimte netjes en het hele proces verliep vlot en volgens afspraak. Kortom: een aanrader voor iedereen die meer uit zijn voertuig wil halen!💯",
  },
  {
    name: "Marco Cornet",
    avatar: `https://ui-avatars.com/api/?name=Marco+Cornet&background=random`,
    date: "4 days ago",
    text: "Vandaag fijn geholpen door Rewien; na een duidelijke uitleg van de aanpak is de tuning zorgvuldig uitgevoerd. Na afloop samen het resultaat beoordeeld: betere gasrespons en pit in de motor. Zeer te tevreden!",
  },
  {
    name: "Kristel van Vliet",
    avatar: `https://ui-avatars.com/api/?name=Kristel+Vliet&background=random`,
    date: "6 days ago",
    text: "Super goede ervaring gehad! Er word je heel duidelijk uitgelegd wat wel en niet kan. En een eerlijk advies zonder alleen aan inkomsten te denken is toch wel een heel goed pluspunt. Ga binnenkort weer terug 😁",
  },
  {
    name: "Thomas Donker",
    avatar: `https://ui-avatars.com/api/?name=Thomas+Donker&background=random`,
    date: "1 week ago",
    text: "Ik ben zeer goed geholpen door de mannen van x-tremetunings! Tijdens het proces kan je boven heerlijk relaxen met wat te drinken en te eten. Echt een aanrader!",
  },
];

const GoogleReviews = () => {
  const [expanded, setExpanded] = useState({});

  const toggleReadMore = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const truncateText = (text, isExpanded) => {
    const maxLength = 100; // Set the maximum length for truncated text
    if (isExpanded || text.length <= maxLength) {
      return text;
    }
    return `${text.substring(0, maxLength)}...`;
  };

  return (
    <section className="max-w-[1152px] mx-auto py-12 px-8">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-8">
        <div>
          <h2 className="flex justify-center sm:justify-start text-lg font-extrabold text-white">
            <span className="mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 85 36"
                className="h-8"
              >
                <g clip-path="url(#a-1)">
                  <path
                    fill="#4285F4"
                    d="M20.778 13.43h-9.862v2.927h6.994c-.345 4.104-3.76 5.854-6.982 5.854-4.123 0-7.72-3.244-7.72-7.791 0-4.43 3.429-7.841 7.73-7.841 3.317 0 5.272 2.115 5.272 2.115l2.049-2.122s-2.63-2.928-7.427-2.928C4.725 3.644 0 8.8 0 14.367c0 5.457 4.445 10.777 10.988 10.777 5.756 0 9.969-3.942 9.969-9.772 0-1.23-.179-1.941-.179-1.941Z"
                  ></path>
                  <path
                    fill="#EA4335"
                    d="M28.857 11.312c-4.047 0-6.947 3.163-6.947 6.853 0 3.744 2.813 6.966 6.994 6.966 3.786 0 6.887-2.893 6.887-6.886 0-4.576-3.607-6.933-6.934-6.933Zm.04 2.714c1.99 0 3.876 1.609 3.876 4.201 0 2.538-1.878 4.192-3.885 4.192-2.205 0-3.945-1.766-3.945-4.212 0-2.394 1.718-4.181 3.954-4.181Z"
                  ></path>
                  <path
                    fill="#FBBC05"
                    d="M43.965 11.312c-4.046 0-6.946 3.163-6.946 6.853 0 3.744 2.813 6.966 6.994 6.966 3.785 0 6.886-2.893 6.886-6.886 0-4.576-3.607-6.933-6.934-6.933Zm.04 2.714c1.99 0 3.876 1.609 3.876 4.201 0 2.538-1.877 4.192-3.885 4.192-2.205 0-3.945-1.766-3.945-4.212 0-2.394 1.718-4.181 3.955-4.181Z"
                  ></path>
                  <path
                    fill="#4285F4"
                    d="M58.783 11.319c-3.714 0-6.634 3.253-6.634 6.904 0 4.16 3.385 6.918 6.57 6.918 1.97 0 3.017-.782 3.79-1.68v1.363c0 2.384-1.448 3.812-3.633 3.812-2.11 0-3.169-1.57-3.537-2.46l-2.656 1.11c.943 1.992 2.839 4.07 6.215 4.07 3.693 0 6.508-2.327 6.508-7.205V11.734h-2.897v1.17c-.89-.96-2.109-1.585-3.726-1.585Zm.269 2.709c1.821 0 3.69 1.554 3.69 4.21 0 2.699-1.865 4.187-3.73 4.187-1.98 0-3.823-1.608-3.823-4.161 0-2.653 1.914-4.236 3.863-4.236Z"
                  ></path>
                  <path
                    fill="#EA4335"
                    d="M78.288 11.302c-3.504 0-6.446 2.788-6.446 6.901 0 4.353 3.28 6.934 6.782 6.934 2.924 0 4.718-1.6 5.789-3.032l-2.389-1.59c-.62.962-1.656 1.902-3.385 1.902-1.943 0-2.836-1.063-3.39-2.094l9.266-3.845-.48-1.126c-.896-2.207-2.984-4.05-5.747-4.05Zm.12 2.658c1.263 0 2.171.671 2.557 1.476l-6.187 2.586c-.267-2.002 1.63-4.062 3.63-4.062Z"
                  ></path>
                  <path
                    fill="#34A853"
                    d="M67.425 24.727h3.044V4.359h-3.044v20.368Z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="a-1">
                    <path fill="#fff" d="M0 0h84.515v36H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            </span>{" "}
            REVIEWS
          </h2>
          <p className="text-lg font-extrabold text-white">
            5.0 <span className="text-yellow-500">★★★★★</span>{" "}
            <span className="font-normal text-white">(90+ reviews)</span>
          </p>
        </div>
        <a
          href="https://www.google.com/search?sca_esv=c702797afd47edb8&rlz=1C1CHBF_enPK1153PK1153&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E6buFmTN3NhTGLfheY65nYkxLNbo_CeUIXVo16WrthMFH_LGEtfqon23zO8HXTiqa922dsKWba05hKaZwC_yFf33NvMg&q=X-TREMETUNINGS+Reviews&sa=X&ved=2ahUKEwjzjN2x-MCNAxXKUKQEHeOQPD8Q0bkNegQIJBAE&biw=1536&bih=695&dpr=1.25"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center bg-[#BD0E0E] text-white mt-5 sm:mt-0 px-5 py-3 rounded-lg hover:bg-[#BD0E0E] transition font-semibold shadow-md"
        >
          Review us on Google
        </a>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((review, index) => (
          <div
            key={index}
            className="bg-black p-6 rounded-lg shadow-md border border-[#BD0E0E]"
          >
            <div className="flex items-center mb-2">
              <img
                src={review.avatar}
                alt={`${review.name}'s avatar`}
                className="w-12 h-12 rounded-full mr-4 self-start"
              />
              <div>
                <h3 className="text-lg font-semibold text-white">
                  {review.name}
                </h3>
                <p className="text-sm text-white">{review.date}</p>
              </div>
            </div>
            <div className="flex items-center text-[#BD0E0E] mb-2">
              {Array(5)
                .fill(0)
                .map((_, i) => {
                  return (
                    <span key={i}>
                      <FaStar className="text-lg" />
                    </span>
                  );
                })}
            </div>
            <p className="text-white mb-2">
              {truncateText(review.text, expanded[index])}
              {review.text.length > 100 && (
                <button
                  onClick={() => toggleReadMore(index)}
                  className="text-white ml-2 underline"
                >
                  {expanded[index] ? "Hide" : "Read More"}
                </button>
              )}
            </p>
            <div className="flex items-center text-white text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                className="mr-2 w-6 h-6"
              >
                <path
                  fill="#2A84FC"
                  d="M21.579 12.234c0-.677-.055-1.359-.172-2.025h-9.403v3.839h5.384a4.615 4.615 0 0 1-1.992 3.029v2.49h3.212c1.886-1.736 2.97-4.3 2.97-7.333Z"
                ></path>
                <path
                  fill="#00AC47"
                  d="M12.004 21.974c2.688 0 4.956-.882 6.608-2.406l-3.213-2.491c-.893.608-2.047.952-3.392.952-2.6 0-4.806-1.754-5.597-4.113H3.095v2.567a9.97 9.97 0 0 0 8.909 5.491Z"
                ></path>
                <path
                  fill="#FFBA00"
                  d="M6.407 13.916a5.971 5.971 0 0 1 0-3.817V7.531H3.095a9.977 9.977 0 0 0 0 8.953l3.312-2.568Z"
                ></path>
                <path
                  fill="#FC2C25"
                  d="M12.004 5.982a5.417 5.417 0 0 1 3.824 1.494l2.846-2.846a9.581 9.581 0 0 0-6.67-2.593A9.967 9.967 0 0 0 3.095 7.53l3.312 2.57c.787-2.363 2.996-4.117 5.597-4.117Z"
                ></path>
              </svg>
              <span>Posted on Google</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8 w-full text-center">
        <a
          href="https://www.google.com/search?sca_esv=c702797afd47edb8&rlz=1C1CHBF_enPK1153PK1153&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E6buFmTN3NhTGLfheY65nYkxLNbo_CeUIXVo16WrthMFH_LGEtfqon23zO8HXTiqa922dsKWba05hKaZwC_yFf33NvMg&q=X-TREMETUNINGS+Reviews&sa=X&ved=2ahUKEwjzjN2x-MCNAxXKUKQEHeOQPD8Q0bkNegQIJBAE&biw=1536&bih=695&dpr=1.25"
          target="_blank"
          className="relative overflow-hidden py-4 px-8 rounded-md bg-white hover:bg-[#BD0E0E] text-black hover:text-white border-none cursor-pointer group font-semibold"
        >
          Read More
        </a>
      </div>
    </section>
  );
};

export default GoogleReviews;
